export default "https://cdn-static.gokick.com/assets/46c46890c219de5164704b27b734f3ae915944d1/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";